import { Link } from "react-router-dom";
import React, { useState, useEffect } from "react";
import PageTitle from "../../components/page-title";
import ProjectFilter from "../../components/project/project-filter";
import ProjectItem from "../../components/project/project-item";
import ProjectData from "../../data/project.json";
import useMasonry from "../../hooks/use-masonry";
import { slugify } from "../../utils";
import axios from "axios";

import cogoToast from "cogo-toast";

const ProjectContainer = () => {
    const { categories } = useMasonry(
        ProjectData,
        ".project-list",
        ".masonry-grid",
        ".messonry-button",
        ".messonry-button li"
    );

    const [data, setData] = useState(null);

    useEffect(() => {
        axios
            .get("https://soul-house-harmony.onrender.com/project/all")
            .then((res) => {
                console.log(res.data);
                const temp = [];
                res.data.allProjects.map((x) => {
                    temp.push({
                        id: x._id,
                        media: { thumb: x.cover },
                        title: x.name,
                    });
                });
                setData(temp);
            })
            .catch((err) => {
                console.log(err);
                cogoToast.info("Error submitting form", {
                    position: "bottom-left",
                });
            });
    }, []);

    const handleDelete = (id) => {
        console.log(id);
        console.log(data);

        axios
            .delete(
                "https://soul-house-harmony.onrender.com/project/delete/" + id,
                {
                    headers: {
                        Authorization: JSON.parse(
                            sessionStorage.getItem("admin")
                        ).token,
                    },
                }
            )
            .then((res) => {
                console.log(res.data);
                const temp = data.filter((d) => d.title !== id);
                cogoToast.success("Project deleted successfully", {
                    position: "bottom-left",
                });
                setData(temp);
            })
            .catch((err) => {
                console.log(err);
                cogoToast.info("Error submitting form", {
                    position: "bottom-left",
                });
            });
    };

    return (
        <div className="section section-padding-03">
            <div className="container">
                <PageTitle title="Latest Projects" />
                {/* <div
                    className="messonry-button"
                    data-aos="fade-up"
                    data-aos-duration="1200"
                >
                    <ProjectFilter categories={categories} />
                </div> */}
            </div>

            <div className="custom-container container-fluid">
                <div className="project-section mt-n4">
                    <div className="row grid" style={{ height: "auto" }}>
                        {data &&
                            data.map((project) => (
                                <div
                                    key={project.id}
                                    className={`col-xl-4 col-md-6 masonry-grid `}
                                    data-aos="fade-up"
                                    data-aos-duration="1200"
                                >
                                    <ProjectItem
                                        data={project}
                                        handleDelete={handleDelete}
                                    />
                                </div>
                            ))}
                    </div>
                </div>
            </div>
        </div>
    );
};

export default ProjectContainer;
